import { getAbTestV2, trackAbTestV2Variant } from 'dibs-ab-tests/exports/clientAbTestV2.ts';

const HP_RECENTLY_SAVED_TEST_NAME = 'HP_RecentlySaved_April2026';

export const trackHpRecentlySavedTest = (): void => {
    trackAbTestV2Variant(HP_RECENTLY_SAVED_TEST_NAME);
};

export const isRecentlySavedTestVariant = (): boolean =>
    getAbTestV2(HP_RECENTLY_SAVED_TEST_NAME)?.variant === 'variant';
